import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomepageComponent} from "./pages/homepage/homepage.component";
import {CategoriesComponent} from "./pages/categories/categories.component";
import {GameDetailComponent} from "./pages/game-detail/game-detail.component";
import {SignupComponent} from "./pages/signup/signup.component";
import {LoginComponent} from "./pages/login/login.component";
import {ProfileComponent} from "./pages/profile/profile.component";
import {ResetpasswordComponent} from "./pages/resetpassword/resetpassword.component";
import {LeaderboardComponent} from "./pages/leaderboard/leaderboard.component";
import { VerificationComponent } from './pages/verification/verification.component';
import {GamesComponent} from "./pages/games/games.component";
import {Error404Component} from "./pages/404 page/error404/error404.component";
import {AboutUsComponent} from "./pages/about-us/about-us.component";
import {TermsConditionsComponent} from "./pages/terms-conditions/terms-conditions.component";
import {SupportComponent} from "./pages/support/support.component";
import {PrivacyPolicyComponent} from "./pages/privacy-policy/privacy-policy.component";
import {ContactUsComponent} from "./pages/contact-us/contact-us.component";
import {FaqComponent} from "./pages/faq/faq.component";
import {NewsPromotionsComponent} from "./pages/news-promotions/news-promotions.component";
import {NewsPromotionDetailComponent} from "./pages/news-promotion-detail/news-promotion-detail.component";

const routes: Routes = [

  { path: '', component: HomepageComponent },
  {path: 'categories', component: CategoriesComponent},
  {path: 'game/:id/:slug', component: GameDetailComponent},
  {path: 'game/:id', component: GameDetailComponent},
  {path: 'game-detail/:id', component: GameDetailComponent},
  {path: 'signup', component: SignupComponent},
  {path: 'login', component: LoginComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'verify', component: VerificationComponent},
  {path: 'leaderboard', component: LeaderboardComponent},
  {path: 'profile', component: ProfileComponent},
  {path: 'resetpassword', component: ResetpasswordComponent},
  {path: 'games', component: GamesComponent},
  {path: 'terms', component: TermsConditionsComponent},
  {path: 'about-us', component: AboutUsComponent},
  {path: 'contact-us', component: ContactUsComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'news-promotions', component: NewsPromotionsComponent},
  {path: 'news-promotions/:id', component: NewsPromotionDetailComponent},
  {path: 'support', component: SupportComponent},
  {path: '**', component: Error404Component},
  {path: '**/**', component: Error404Component},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {


}
